import cobalt from './productImages/cobalt.jpg'
import damas from './productImages/damas.jpg'
import wash from './productImages/wash.jpg' 
import wash2 from './productImages/wash2.jpg' 
import tel from './productImages/telefon.jpg'
import tel2 from './productImages/telefon2.jpg'
import u from './productImages/u.jpg'
import hovli from './productImages/hovli.jpg'
import divan from './productImages/divan.jpg'
import divan2 from './productImages/divan2.jpg'
import reyka from './productImages/reyka.jpg'
import strapil from './productImages/strapil.jpg'
import sigir from './productImages/mol.jpg'
import qoy from './productImages/qoy.jpg'

export const products = [
    {
        id: 0,
        title: "Cobalt",
        price: 125000,
        location: "Tashkent",
        images: [cobalt, cobalt, cobalt, cobalt],
        rangi: "oq",
        yurgan: 52000,
        phoneNumber: "+998949111180"
    },
    {
        id: 1,
        title: "Damas",
        price: 135000,
        location: "Tashkent",
        images:[damas,damas,damas,damas],
        rangi: "oq",
        yurgan: 45000,
        phoneNumber: "+998949111180"
    },
    {
        id: 2,
        title: "Kir moshina",
        price: 1000000,
        location: "Namangan",
        images:[wash,wash,wash,wash],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 3,
        title: "Kir moshina",
        price: 1500000,
        location: "Namangan",
        images:[wash2,wash2,wash2,wash2],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 4,
        title: "Telefon",
        price: 1500000,
        location: "Namangan",
        images:[tel, tel, tel, tel],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 5,
        title: "Telefon",
        price: 1700000,
        location: "Namangan",
        images:[tel2, tel2, tel2, tel2],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 6,
        title: "Uchastka",
        price: 1700000,
        location: "Namangan",
        images:[u, u, u, u],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 7,
        title: "UY",
        price: 1250000,
        location: "Namangan",
        images:[hovli,hovli, hovli, hovli],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 8,
        title: "Divan",
        price: 1000000,
        location: "Namangan",
        images:[divan,divan, divan, divan],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 9,
        title: "Divan",
        price: 3000000,
        location: "Namangan",
        images:[divan2,divan2, divan2, divan2],
        rangi: "oq",
        phoneNumber: "+998949111180"
    },
    {
        id: 10,
        title: "Reyka",
        price: 3000000,
        location: "Namangan",
        images:[reyka , reyka, reyka, reyka],
        materialType:"terak",
        phoneNumber: "+998949111180"
    },
    {
        id: 11,
        title: "strapil",
        price: 456051,
        location: "Namangan",
        images:[strapil , strapil, strapil, strapil],
        materialType:"Qarag'ay",
        phoneNumber: "+998949111180"
    },
    {
        id: 12,
        title: "Sigir",
        price: 12000000,
        location: "Namangan",
        images:[sigir , sigir, sigir, sigir],
        phoneNumber: "+998949111180"
    },
    {
        id: 13,
        title: "Qoy",
        price: 210000,
        location: "Namangan",
        images:[qoy , qoy, qoy, qoy],
        phoneNumber: "+998949111180"
    }
    
    
]